import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { AdaptShellModule } from "@common/shell/shell.module";
import { AdaptCommonUserModule } from "@common/user/adapt-common-user.module";
import { AdaptCommonDialogModule } from "@common/ux/adapt-common-dialog/adapt-common-dialog.module";
import { AdaptButtonModule } from "@common/ux/button/button.module";
import { AdaptCollapsibleModule } from "@common/ux/collapsible/collapsible.module";
import { ColourPickerComponent } from "@common/ux/colour-picker/colour-picker.component";
import { AdaptDashboardElementModule } from "@common/ux/dashboard-element/dashboard-element.module";
import { AdaptEntityValidatorModule } from "@common/ux/entity-validator/entity-validator.module";
import { AdaptHtmlEditorModule } from "@common/ux/html-editor/html-editor.module";
import { IconPickerComponent } from "@common/ux/icon-picker/icon-picker.component";
import { AdaptIncompleteWorkModule } from "@common/ux/incomplete-work/incomplete-work.module";
import { AdaptLinkDisabledModule } from "@common/ux/link-disabled/link-disabled.module";
import { AdaptLoadingSpinnerModule } from "@common/ux/loading-spinner/loading-spinner.module";
import { AdaptMenuModule } from "@common/ux/menu/menu.module";
import { AdaptTooltipModule } from "@common/ux/tooltip.directive/tooltip.module";
import { AdaptActivityFeedModule } from "@org-common/lib/activity-feed/activity-feed.module";
import { TeamCardComponent } from "@org-common/lib/architecture/organisation-map/team-card/team-card.component";
import { AdaptAuthorisationModule } from "@org-common/lib/authorisation/authorisation.module";
import { AuthorisationService } from "@org-common/lib/authorisation/authorisation.service";
import { AdaptCallToActionModule } from "@org-common/lib/call-to-action/call-to-action.module";
import { AdaptDirectorySharedModule } from "@org-common/lib/directory-shared/directory-shared.module";
import { AdaptFeaturesModule } from "@org-common/lib/features/features.modules";
import { AdaptGuidingPhilosophyModule } from "@org-common/lib/guiding-philosophy/guiding-philosophy.module";
import { AdaptCommonTeamsModule } from "@org-common/lib/teams/common-teams.module";
import { DisplayTeamTypeComponent } from "@org-common/lib/teams/display-team-type/display-team-type.component";
import { AdaptTeamDashboardSharedModule } from "@org-common/lib/teams/team-dashboard-shared/team-dashboard-shared.module";
import { AdaptTeamsSharedModule } from "@org-common/lib/teams/teams-shared.module";
import { AdaptValuesConstitutionModule } from "@org-common/lib/values-constitution/values-constitution.module";
import { AdaptZoneMapModule } from "@org-common/lib/zone-map/zone-map.module";
import { AdaptProcessMapSharedModule } from "app/features/architecture/process-map/process-map-shared.module";
import { AdaptSystemisationModule } from "app/features/systemisation/systemisation.module";
import { AdaptEmbedShellModule } from "app/services/layout/embed-shell.module";
import { DxCheckBoxModule, DxListModule, DxScrollViewModule, DxSelectBoxModule, DxSortableModule, DxTextBoxModule, DxTreeViewModule } from "devextreme-angular";
import { AddTeamConfirmStepComponent } from "./add-team-workflow/add-team-confirm-step/add-team-confirm-step.component";
import { AddTeamCreateTeamButtonComponent } from "./add-team-workflow/add-team-create-team-button/add-team-create-team-button.component";
import { AddTeamCustomiseStepComponent } from "./add-team-workflow/add-team-customise-step/add-team-customise-step.component";
import { AddTeamDetailsStepComponent } from "./add-team-workflow/add-team-details-step/add-team-details-step.component";
import { AddTeamFeaturesStepComponent } from "./add-team-workflow/add-team-features-step/add-team-features-step.component";
import { AddTeamMembersStepComponent } from "./add-team-workflow/add-team-members-step/add-team-members-step.component";
import { TeamSystemsDashboardElementComponent } from "./team-systems-dashboard-element/team-systems-dashboard-element.component";
import { TeamsAuthService } from "./teams-auth.service";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        AdaptTooltipModule,
        AdaptButtonModule,
        AdaptLoadingSpinnerModule,
        AdaptCommonDialogModule,
        AdaptDirectorySharedModule,
        AdaptActivityFeedModule,
        AdaptIncompleteWorkModule,
        AdaptFeaturesModule,
        AdaptLoadingSpinnerModule,
        AdaptShellModule,
        AdaptAuthorisationModule,
        AdaptProcessMapSharedModule,
        AdaptTeamDashboardSharedModule,
        DxSortableModule,
        DxSelectBoxModule,
        DxListModule,
        DxTextBoxModule,
        DxCheckBoxModule,
        TeamCardComponent,
        AdaptGuidingPhilosophyModule,
        AdaptValuesConstitutionModule,
        AdaptEmbedShellModule,
        AdaptHtmlEditorModule,
        AdaptEntityValidatorModule,
        AdaptSystemisationModule,
        AdaptTeamsSharedModule,
        AdaptZoneMapModule,
        AdaptMenuModule,
        AdaptDashboardElementModule,
        AdaptLinkDisabledModule,
        AdaptCollapsibleModule,
        AdaptCommonTeamsModule,
        AdaptCallToActionModule,
        DxScrollViewModule,
        DxTreeViewModule,
        AdaptCommonUserModule,
        IconPickerComponent,
        ColourPickerComponent,
        DisplayTeamTypeComponent,
    ],
    declarations: [
        TeamSystemsDashboardElementComponent,
        AddTeamDetailsStepComponent,
        AddTeamMembersStepComponent,
        AddTeamFeaturesStepComponent,
        AddTeamCustomiseStepComponent,
        AddTeamConfirmStepComponent,
        AddTeamCreateTeamButtonComponent,
    ],
    exports: [
        TeamSystemsDashboardElementComponent,
    ],
})

export class AdaptTeamsModule {
    // prevent being optimised by tree-shaker
    public readonly workflowStepComponents = [
        AddTeamDetailsStepComponent,
        AddTeamMembersStepComponent,
        AddTeamFeaturesStepComponent,
        AddTeamCustomiseStepComponent,
        AddTeamConfirmStepComponent,
    ];

    constructor(authorisationService: AuthorisationService) {
        TeamsAuthService.registerAccess(authorisationService);
    }
}

